// React Lazily
import { lazily } from 'react-lazily'

// Interface
import { IRoute } from 'routes/route.interface'

// Constant
import { LAYOUT } from 'constant/layout.constant'
import { ACCOUNT_MODULE, ACCOUNT_URL } from 'constant/url.constant'

// UI
const { AccountLoginCallback, AccountLoginSilentCallback, AccountLogoutCallback } = lazily(() => import('pages/account'))

const accountRoutes: IRoute[] = [
  {
    path: ACCOUNT_URL.LOGIN_CALLBACK,
    component: AccountLoginCallback,
    layout: LAYOUT.ACCOUNT,
    exact: true,
    meta: {
      module: ACCOUNT_MODULE,
      requireAuth: false,
      attrs: {
        label: 'account.title.loginCallback',
      },
    },
  },
  {
    path: ACCOUNT_URL.LOGIN_SILENT_CALLBACK,
    component: AccountLoginSilentCallback,
    layout: LAYOUT.ACCOUNT,
    exact: true,
    meta: {
      module: ACCOUNT_MODULE,
      requireAuth: false,
      attrs: {
        label: 'account.title.silentLoginCallback',
      },
    },
  },
  {
    path: ACCOUNT_URL.LOGOUT_CALLBACK,
    component: AccountLogoutCallback,
    layout: LAYOUT.ACCOUNT,
    exact: true,
    meta: {
      module: ACCOUNT_MODULE,
      requireAuth: false,
      attrs: {
        label: 'account.title.logoutCallback',
      },
    },
  },
]

export { accountRoutes }
